import { render } from "./Collection_Record.vue?vue&type=template&id=21ec18f5"
import script from "./Collection_Record.vue?vue&type=script&lang=js"
export * from "./Collection_Record.vue?vue&type=script&lang=js"

import "./Collection_Record.vue?vue&type=style&index=0&id=21ec18f5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__